import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Slider } from '../slider/slider';
import { SliderType } from '../slider/types/type';
import { BarContainerStyled, BarStyled, ParentContainerStyled, ProgressBarStyled, } from './progressBar.styled';
const SLIDER_MAX_VALUE = 1000;
const SLIDER_MIN_VALUE = 0;
const SLIDER_PERCENTAGE_CONVERSION = 10;
const ProgressBarStandaloneComponent = ({ dataTestIdBar = 'bar', dataTestIdProgressBar = 'progress-bar', barAriaLabel, color, progressAnimation, progressCompleted, sizeStyles, styles, tooltip, onChange, onDragEnd, onDragStart, }, ref) => {
    return (_jsx(ParentContainerStyled, { ref: ref, styles: styles, children: _jsx(BarContainerStyled, { styles: styles, children: styles.useAsSlider && styles.sliderVariant ? (_jsx(Slider, { ariaLabel: barAriaLabel, max: SLIDER_MAX_VALUE, min: SLIDER_MIN_VALUE, tooltip: tooltip, type: SliderType.CONTINUOUS, 
                // Convert 0-100 values to 0 - 1000
                value: progressCompleted * SLIDER_PERCENTAGE_CONVERSION, variant: styles.sliderVariant, onChange: (newValue) => {
                    if (onChange && !Array.isArray(newValue)) {
                        // in order to retun a value 0 - 100
                        onChange(newValue / SLIDER_PERCENTAGE_CONVERSION);
                    }
                }, onDragEnd: onDragEnd, onDragStart: onDragStart })) : (_jsxs(_Fragment, { children: [_jsx(BarStyled, { color: color?.bar, "data-testid": dataTestIdBar, sizeStyles: sizeStyles, styles: styles }), _jsx(ProgressBarStyled, { color: color?.progressBar, "data-testid": dataTestIdProgressBar, progressAnimation: progressAnimation, progressCompleted: progressCompleted, sizeStyles: sizeStyles, styles: styles })] })) }) }));
};
/**
 * @description
 * ProgressBar component is used to show a progress bar.
 * @param {React.PropsWithChildren<IProgressBarStandAlone>} props
 * @returns {JSX.Element}
 */
export const ProgressBarStandalone = React.forwardRef(ProgressBarStandaloneComponent);
//# sourceMappingURL=progressBarStandAlone.js.map